export default __webpack_public_path__ + "static/corum-fk-13b78619f3e4b50742e059bdfa635369.png";